import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { Icons } from "@repo/ui";
import { type FC, useState } from "react";

export interface SingleRowProps {
	dueDate: string;
	description: string;
	content: JSX.Element;
}

interface RowProps {
	row: SingleRowProps;
	titles: string[];
}

const Row: FC<RowProps> = ({ row, titles }) => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<TableRow>
				<TableCell>
					<IconButton
						aria-label="expand row"
						size="small"
						onClick={() => setOpen(!open)}
					>
						{open ? (
							<Icons.Minus sx={{ width: "2.1rem", height: "2.1rem" }} />
						) : (
							<Icons.Plus sx={{ width: "2.1rem", height: "2.1rem" }} />
						)}
					</IconButton>
				</TableCell>
				{titles.map((_, i) => (
					<TableCell
						sx={{
							color: (theme) =>
								open
									? theme.palette.primary.dark
									: theme.palette.grey.ultraDark,
						}}
						key={i}
					>
						{Object.values(row)[i]}
					</TableCell>
				))}
			</TableRow>
			<TableRow>
				<TableCell sx={{ pt: 0, pb: 0 }} colSpan={6}>
					<Collapse in={open} timeout={0}>
						<Stack sx={{ pl: 8, py: 3 }} spacing={4}>
							{row.content}
						</Stack>
					</Collapse>
				</TableCell>
			</TableRow>
		</>
	);
}

export default Row;
